import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-dropdown-button",
  templateUrl: "./dropdown-button.component.html",
  styleUrls: ["./dropdown-button.component.scss"],
})
export class DropdownButtonComponent implements OnInit {
  @Input()
  public defaultCollapse: boolean;
  public collapse = true;

  ngOnInit() {
    this.collapse = this.defaultCollapse;
  }
}
